<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2 ">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <!-- Mostrar saldo si hay owner -->
    <div *ngIf="owner && balanceAmount !== null" class="px-8 sm:px-10 py-4 flex justify-center">
      <div class="bg-white rounded-lg shadow p-4 flex items-center gap-4">
        <img class="rotate-minus12" width="112px" src="./assets/icons/card.svg" alt="card" />
         <img width="32" height="32" src="./assets/icons/call-white.svg" />
        <div>
          <div class="text-sm font-medium text-gray-600">Saldo del usuario</div>
          <div class="text-2xl font-bold text-green-600">{{ balanceAmount | number:'1.2-2' }} €</div>
        </div>
      </div>
    </div>
    
    <br><br>
    <div class="flex justify-center items-center gap-4 py-4 bg-white rounded-lg shadow-md mx-4">
        <div class="flex flex-col items-start">
          <label for="fechaInicio" class="text-sm font-medium text-gray-700">Fecha inicio</label>
          <input
            id="fechaInicio"
            type="date"
            [(ngModel)]="fechaInicio"
            class="mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          />
        </div>

        <div class="flex flex-col items-start">
          <label for="fechaFin" class="text-sm font-medium text-gray-700">Fecha fin</label>
          <input
            id="fechaFin"
            type="date"
            [(ngModel)]="fechaFin"
            class="mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          />
        </div>

        <div class="flex items-end h-full pt-5">
          <button
            (click)="buscarPorFechas()"
            class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg shadow transition-colors"
          >
            Buscar
          </button>
        </div>
      </div>

    <br>


    <div class="py-1 flex justify-center dashboard-header">
      <h2 class="text-xl text-white font-semibold mb-0">Transacciones por usuario</h2>
    </div>
    <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">
      <div class="flex mt-8 mb-8 inset-x-0 bottom-0">
        <div *ngIf="loadingTransactions" class="w-full text-center">
          <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
        </div>
        <!-- se quita el filtro de transacciones se debe colocar un filtro que valla directamente al api
         -->
        <app-generic-list class="w-full flex-col" *ngIf="transactionList.length > 0 && !loadingTransactions"
          filterKeyPrefix="transactions"
          [items]="transactionList"
          (itemClick)="onTransactionClick($event)"
          [filterFields]="filterTransactions"
          [showFilters]="true"
          [isFiltersCollapsed]="true"
          [allowDownload]="true"
          (filtersChanged)="onFiltersChanged($event)"
          (pageChanged)="loadMoreTransactions()"
          (filteredCount)="filteredCounts.transactionList = $event"
          [pageSize]="10">
          
          <ng-template #tableHeaderTemplate>
            <div class="grid grid-cols-9 gap-4 items-center border-b py-2 font-semibold text-sm text-gray-700">
              <div class="col-span-1 truncate">Nombre</div>
              <div class="col-span-1 truncate">Phonenumber</div>
              <div class="col-span-1 truncate">Email</div>
              <div class="col-span-1 truncate">Fecha Alta</div>
              <div class="col-span-1">CallOut</div>
              <div class="col-span-1">Call</div>
              <div class="col-span-1">Esim</div>
              <div class="col-span-1">Transferencia</div>
              <div class="col-span-1">Activo</div>
            </div>
          </ng-template>



          <ng-template #itemTemplate let-item>
            <div class="grid grid-cols-9 gap-4 items-center border-b py-2">
              <div class="col-span-1 truncate text-sm text-gray-500" title="nombre">{{ item.full_name}} </div>
              <div class="col-span-1 truncate text-sm text-gray-500" title="Telefono">{{ item.phonenumber }}</div>
              <div class="col-span-1 truncate text-sm text-gray-500" title="Correo">{{ item.email }}</div>
              <div class="col-span-1 truncate text-sm" *ngIf="item.usercreatedate">{{ item.usercreatedate | date:'yyyy/MM/dd' }}</div>
                <div class="col-span-1 text-sm text-gray-500" title="Llamada saliente">{{ item.Callout | number:'1.2-5' }}</div>
              <div class="col-span-1 text-sm text-gray-500" title="Call">{{ item.Call | number:'1.2-2' }}</div>
              <div class="col-span-1 text-sm text-gray-500" title="Esim" >{{ item.esim  | number:'1.2-2'}}</div>
              <div class="col-span-1 text-sm text-gray-500" title="Transferencia">0.0 </div>
              <div class="col-span-1 text-sm text-gray-500" title="Activo">{{ item.Activo }}</div>
              
            </div>
          </ng-template>

          <div *ngIf="filteredCounts.transactionList == 0 && !loadingTransactions" class="w-full content-center h-[200px]">
            <div class="!font-medium text-center">
              <mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">receipt_long</mat-icon><br />
              No se encontraron transacciones
            </div>
          </div>
        </app-generic-list>
      </div>
    </div>
  </div>
  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>



<style>
  .grid {
    display: grid;
  }

  .grid-cols-2 {
    grid-template-columns: repeat(2, 1fr);
  }

  .gap-4 {
    gap: 16px;
  }

  .flex {
    display: flex;
  }

  .flex-col {
    flex-direction: column;
  }

  .w-full {
    width: 100%;
  }

  :host {
  display: block;
  width: 100%;
}
</style>  